/**
 * 分身口播的语速口径 —— 从 features/digital-human/model/dhCreateOptions 提到 shared(1006):
 * 作品卡投影(entities/work/model/mappers.mapDh)也要按文案估片长,而 entities 不能 import features。
 * dhCreateOptions 原名重导出,既有调用方不变。
 */

/** 口播语速(字/秒);PC/H5/后端(DhVideoBilling.CHARS_PER_SECOND)三处对齐。 */
export const CHARS_PER_SECOND = 4.5;

/** 文案字数 → 估算成片秒数(向上取整)。 */
export const estSecondsFromChars = (chars: number): number => Math.ceil(chars / CHARS_PER_SECOND);
